import { render, staticRenderFns } from "./UserAuth.vue?vue&type=template&id=36df8ca6&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=ts"
export * from "./UserAuth.vue?vue&type=script&lang=ts"
import style0 from "./UserAuth.vue?vue&type=style&index=0&id=36df8ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df8ca6",
  null
  
)

export default component.exports